export const FIRMWARE_UPDATE_PROGRESS = 'progress';
export const FIRMWARE_UPGRADE = 'firmwareUpgrade';
